import React from "react";
import classnames from "classnames";
import GoToPage from "./goToPage";
import img_banner_herramientas_mobile from "../assets/images/img_banner_herramientas_mobile.png";
import img_ondas_mobile from "../assets/images/img_ondas_mobile.png";
const TileToolsMobile = (props) => {
  const {
    bgImage,
    icon,
    firstImage,
    secondImage,
    title,
    buttonText,
    page,
    text1,
    text2,
    centerImage,
  } = props;
  const styles = classnames(props.width, props.height, props.bgColor); 
  return (
    <div className="w-full h-fit lg:mb-0 md:mb-10 sm:mb-5 mb-5">
      <div className="flex flex-col relative">
        <img
          loading="lazy"
          className="object-fill h-full w-full"
          src={bgImage || img_banner_herramientas_mobile}
          alt=""
        ></img>
        <div className="grid grid-cols-1 grid-rows-4 absolute bottom-0 w-full h-full ">
          <div className="h-fit pl-8 pt-3">
            <img
              loading="lazy"
              src={icon}
              className="lg:w-20 md:w-20 sm:w-20 w-14"
            ></img>
          </div>
          <div className="grid grid-rows-2 grid-cols-1 mb-20 ">
            <div className="flex justify-center items-center">
              <h1 className="lg:md:text-6xl md:text-5xl sm:text-3xl text-3xl font-bold text-center">
                {text1} <br /> {text2}
              </h1>
            </div>
            <div className="flex justify-center items-center mt-14">
              <GoToPage
                page={page}
                side="right"
                name={buttonText}
                fontSizeXL="xl:text-2xl"
                fontSizeL="lg:text-base"
                fontSizeM="md:text-base"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-6"
                iconColor="invert"
                iconMargin="ml-5"
              ></GoToPage>
            </div>
          </div>
          <div className="grid grid-cols-3 row-span-2">
            {firstImage && (
              <div className="relative  col-span-2 ">
                <img
                  loading="lazy"
                  className=" absolute left-0 bottom-0 ld:w-[25rem] md:w-[40rem] sm:w-[25rem] w-[17rem]"
                  src={firstImage}
                  alt=""
                ></img>
              </div>
            )}
            {secondImage && (
              <div className="relative">
                <img
                  loading="lazy"
                  className="absolute right-0 w-[90%] bottom-0 mb-24"
                  src={img_ondas_mobile}
                  alt=""
                ></img>
              </div>
            )}
            {centerImage && (
              <div className="relative w-[100%] col-span-3 flex justify-center items-center">
                <img
                  loading="lazy"
                  className={
                    title === "jaguar"
                      ? "absolute bottom-0 w-[100%]"
                      : " w-[100%] p-5"
                  }
                  src={centerImage}
                  alt=""
                ></img>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TileToolsMobile;
